import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DropzoneConfigInterface, DropzoneComponent } from 'ngx-dropzone-wrapper';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})
export class UploadFileComponent implements OnInit {
  //Configuracion para el [DropzoneComponent]
  public configUploadFile: any;
  //Titulo del modal
  public name: string = "";
  //Titulo del modal
  public message: string;
  //Booleano para el boton de summit
  public clicked = false;
  //Configuracion para el [DropzoneComponent]
  public dropzoneConfig: DropzoneConfigInterface;
  public dataToSend: any;
  //Array donde se almacenan los archivos que uno va agregando
  public filesAdded: any[] = [];

  formData = new FormData();
  @ViewChild(DropzoneComponent) dropzone!: DropzoneComponent;
  constructor(
    public matDialog: MatDialog,
    // Es una referencia al diálogo para subir archivos
    public dialog: MatDialogRef<UploadFileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastrService: ToastrService,
  ) {
    //Seteamos los datos que se mandan del componente
    this.message = data.message;
    this.configUploadFile = data.configUploadFile;
    this.dropzoneConfig = this.configUploadFile;
    this.dropzoneConfig.url = `${environment.urlBase}`+ this.dropzoneConfig.url;

    // Dropzone hace su propio XHR y NO pasa por el interceptor HTTP de Angular,
    // así que hay que adjuntar el token de sesión a mano. Sin esto, las rutas de
    // subida que exigen sesión (p.ej. certificados) responden 401. Misma clave
    // que headers.service.ts (localStorage 'token').
    const token = localStorage.getItem('token');
    if (token) {
      this.dropzoneConfig.headers = {
        ...(this.dropzoneConfig.headers || {}),
        Authorization: `Bearer ${token}`,
      };
    }



  }

  ngOnInit(): void {



  }
  public onUploadSuccess(args: any): void {
    // Cerramos el diálogo utilizando el segundo argumento pasado a la función
    // args[1] representa el la respuesta del servicio
    this.closeDialog(args[1]);

  }

  public onUploadError(args: any): void {
    // Cerramos el diálogo utilizando el segundo argumento pasado a la función
    // args[1] representa el la respuesta del servicio
    this.closeDialog(args[1]);

  }

  public onAddedFile(file: any): void {
    // Obtenemos el índice del archivo recién agregado en la lista de archivos de Dropzone
    const index = this.dropzone.directiveRef?.dropzone().files.length - 1;
    // Agregamo el archivo a la lista de archivos agregados

    this.filesAdded.push({ index: index, newName: file.name, oldName: file.upload.filename })

  }
  onRemovedFile(file: any) {
    // Obtenemos el índice del archivo que se va a eliminar
    const index = file.index;
    // Eliminamos el archivo de la lista de archivos agregados utilizando su índice
    this.filesAdded.splice(index, 1);
    // Actualizamos los índices de los archivos restantes en la lista
    this.filesAdded.forEach((f, i) => f.index = i);
  }


  onSubmit() {
    console.log(this.dropzoneConfig);

    // Configuración del mensaje y nombre para el cuadro de diálogo de confirmación
    let dataToDialog = {
      message: `¿Estas seguro que quieres subir los archivos?`,
      name: 'Asegurate de que sean los correctos'
    }
    // Abrimos el cuadro de diálogo de confirmación
    this.matDialog.open(ConfirmDialogComponent, {
      data: dataToDialog,
      width: '40%'
    }).afterClosed().subscribe((confirm: boolean) => {
      if (confirm == true) {
        // Confirmación positiva: proceder con la subida de archivos
        if (this.dropzoneConfig.uploadMultiple) {
          // Subida múltiple de archivos
          let data = this.data.dataToSend;
          console.log(data);

          this.dropzone.directiveRef?.dropzone().on('sendingmultiple', (files: any, xhr:any, formData:any) => {
            // Agregamos los nombres generados de los archivos a los datos que se envían en el formulario, (Se utilizan para modificar los nombres de los mismo)
            if (this.data.dataToSend.folderName && this.data.dataToSend.folderName) { data.generatedFileNames = this.filesAdded }
            formData.append('dataToSend', JSON.stringify(data));
          });

          this.dropzone.directiveRef?.dropzone().processQueue();

        } else {
          let data = this.data.dataToSend;

          let type = 1;
          if (data.type) {
            data.type = type;
          }
          this.dropzone.directiveRef?.dropzone().on('sending', (files: any, xhr:any, formData:any) => {
            // Agregamos los nombres generados de los archivos a los datos que se envían en el formulario, (Se utilizan para modificar los nombres de los mismo)
            if (this.data.dataToSend.folderName && this.data.dataToSend.folderName) { data.generatedFileNames = this.filesAdded } formData.append('dataToSend', JSON.stringify(data));
          })
          console.log(this.dropzone.directiveRef)

          this.dropzone.directiveRef?.dropzone().processQueue();
        }
      } else {
      }
      this.ngOnInit()
    });
  }

  
  closeDialog(response?: any) {
    if (!response) {
      this.dialog.close({ success: false, message: "Cancelado" });

    } else {
      this.dialog.close(response);
      
    }
  }

  onMaxFilesExceeded() {
    this.toastrService.error('Se ha superado el límite de archivos')
  }
}

